import React from 'react'

import ModalBottomSheet from '@zet/common/components/modalBottomSheet'

import VerifyOtp from '../components/verifyOtp'

type ICompleteProfile = {
  mobileNumber: string
  isVisible: boolean
  setIsVisible: (x: boolean) => void
  handleResetOtp: (phoneNumber: string) => void
  handleSubmit: (otp: string, phoneNumber: string) => void
  isVerifying: boolean
  heading: string
}
export function VerifyOTPBottomSheet({
  mobileNumber,
  isVisible,
  setIsVisible,
  handleResetOtp,
  handleSubmit,
  isVerifying,
  heading,
}: ICompleteProfile) {
  return (
    <ModalBottomSheet
      visible={isVisible}
      sheetName={'complete_existing_profile'}
      onDismiss={() => setIsVisible(false)}
    >
      <VerifyOtp
        mobileNumber={mobileNumber}
        setIsVisible={setIsVisible}
        onClickSubmit={handleSubmit}
        onReset={handleResetOtp}
        isVerifying={isVerifying}
        heading={heading}
      />
    </ModalBottomSheet>
  )
}
